import { isNil, orderBy } from "lodash-es";
import { CompetitorPost } from "@/services/competitor_monitoring";
import { Post } from "@/services/social_media";

export function isOrganizationPost(post: Post | CompetitorPost): post is Post {
  return "resource" in post;
}
export function isCompetitorPost(
  post: Post | CompetitorPost,
): post is CompetitorPost {
  return "competitor" in post;
}

// Organization and competitor posts come from separate tables, so a bare PK
// is not an identity where the two are mixed.
export function postKey(post: Post | CompetitorPost): string {
  return `${isCompetitorPost(post) ? "competitor" : "self"}-${post.pk}`;
}

// Unknown counts sort last in both directions, as on the server.
export function orderPostsByMetric<T extends Post | CompetitorPost>(
  posts: T[],
  metric: keyof Post & keyof CompetitorPost,
  direction: "asc" | "desc",
): T[] {
  return orderBy(
    posts,
    [(post) => isNil(post[metric]), (post) => post[metric]],
    ["asc", direction],
  );
}
